import { Component, OnInit } from '@angular/core';
import { CobrancaDash } from '../models/cobranca-dash';
import { DashboardStoreService } from '../services/dashboard-store.service';
import { Observable } from 'rxjs';
import { FunctionService } from 'src/app/services/function.service';

@Component({
  selector: 'app-dash-cobrancas',
  templateUrl: './dash-cobrancas.component.html',
  styleUrls: ['./dash-cobrancas.component.scss'],
})
export class DashCobrancasComponent implements OnInit {
  cobranca$: Observable<CobrancaDash>;

  constructor(private dashboardStore: DashboardStoreService, public func: FunctionService) {}

  ngOnInit() {
    this.getDashData();
  }

  getDashData() {
    this.cobranca$ = this.dashboardStore.cobranca$;
  }
}
